import ReactDOM from "react-dom"

import { install } from "resize-observer"

// Font Awesome — registra apenas os ícones necessários (ver src/config/faIcons.js)
import "./config/faIcons"

// Estilos Internos
import "./assets/scss/Style.scss"

// Helper Classes
// import "../node_modules/helper-style-classes"

// Estilos Externos
// import "../node_modules/animate.css"
import "./assets/scss/bootstrap-custom.scss"
import "../node_modules/react-slideshow-image/dist/styles.css"
import "../node_modules/react-vertical-timeline-component/style.min.css"

import App from "./App"

import { preloadBannerImage } from "./helpers/BannerTools"

// Dispara o download do banner (LCP) antes do React montar
preloadBannerImage()

if (!window.ResizeObserver) install()

ReactDOM.render(<App />, document.getElementById("root"))
